




















































import { Component, Emit, PropSync, Vue } from "vue-property-decorator";

@Component({
  name: "base-alert",
})
export default class BaseAlert extends Vue {
  @PropSync("type", { type: String, default: "default" })
  public syncedType!: string; // Alert type

  @PropSync("icon", { type: String, default: "" })
  public syncedIcon!: string; // Alert icon. Will be overwritten by default slot

  @PropSync("dismissible", { type: Boolean, default: false })
  public syncedDismissible!: boolean; // Whether alert is closes when clicking

  @PropSync("visible", { type: Boolean, default: false })
  public syncedVisible!: boolean;

  @Emit("update:visible")
  private dismissAlert() {
    return false;
  }
}
